import PropTypes from "prop-types";
import React, { useEffect } from "react";

import styled from "styled-components/macro";

import useUpdateSetting from "Signups/FamilyRegistration/Shared/useUpdateSetting";

import FnrCheckbox from "UI/FnrEnrichedCheckbox/FnrCheckbox";
import FnrLoadingBricks from "UI/FnrLoadingBricks";

AdminSelector.propTypes = {
  admin: PropTypes.shape({
    ID: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    enabled: PropTypes.bool.isRequired,
  }).isRequired,
  setError: PropTypes.func.isRequired,
};

export default function AdminSelector({ admin, setError }) {
  const { ID, name, email, enabled } = admin;
  const { updateSetting, saving, error } = useUpdateSetting();

  const handleToggle = async () => {
    setError(undefined);
    await updateSetting({
      setting: "finishedNotificationRecipients",
      adminID: ID,
      value: !enabled,
    });
  };

  useEffect(
    function syncErrorToParentError() {
      setError(error);
    },
    [error, setError]
  );

  return (
    <Wrapper>
      <CheckboxWrapper>
        {saving ? (
          <FnrLoadingBricks show={saving} size={20} />
        ) : (
          <FnrCheckbox
            on={enabled}
            toggleOn={handleToggle}
            id={ID}
            color={"#016099"}
            // disabled={isDisabled}
          />
        )}
      </CheckboxWrapper>

      <AdminData>
        <div>{name}</div>
        <div>{email}</div>
      </AdminData>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #f1f4f6;
  border-radius: 6px;
`;

const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 28px;
`;

const AdminData = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 10px;

  > div:last-child {
    font-size: 12px;
    color: #6f6f6f;
  }
`;
